import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Notfound } from './app/pages/notfound/notfound';
import { authGuard, menuGuard } from './app/config/auth.guard';
import { helpGuard } from './app/help/help.guard';

export const appRoutes: Routes = [
    { path: 'ajuda', canActivate: [authGuard, helpGuard], loadComponent: () => import('./app/help/help-page.component').then(m => m.HelpPageComponent) },
    {
        path: '',
        component: AppLayout,
        children: [
            { path: '', component: Dashboard, canActivate: [authGuard] },
            { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') , canActivate: [authGuard], canActivateChild: [menuGuard]},
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];
